module.exports = __webpack_public_path__ + "215a865046d2f713b7524211c52de7de.png";